import * as React from 'react';
import { Accordion } from 'damco-components';
import PropertyDisplay from 'components/cost-revenue/PropertyDisplay';
import Table from 'components/data-table/Table';
import { IETSProps } from '../../utils/models';
import { formatData, sortElementByKey } from 'utilities/util';
import { redirectToViewInvoice } from 'utilities/route-utils';

class ETSDetails extends React.Component<IETSProps> {
    public createLink = (data: any) => {
        this.props.link(String(`/job-costing/booking/${data!.id}`));
    };
    public render() {
        const docData = this.props.fcr;
        docData.data.map((data: any) => {
            data.fcrNumber = data.originalDocumentNumber;
            data.fcrType = data.type;
            data.shipmentType = `${data.shipmentTypeAtOrigin}/${data.shipmentTypeAtDestination}`;
            data.placeOfReceipt = `${data.placeOfReceiptName}`;
            data.portOfLoading = `${data.portOfLoadingName}`;
            data.portOfDischarge = `${data.portOfDischargeName}`;
            data.creationDate = data.createdDate;
            return data;
        });
        const extraDocs = JSON.parse(JSON.stringify(docData));
        if (extraDocs.data && extraDocs.data.length) {
            extraDocs.data = extraDocs.data.filter((val: any) => val.fcrNumber && val.fcrNumber.startsWith('EED'));
        }
        const exceptExtraDocs = JSON.parse(JSON.stringify(docData));
        if (exceptExtraDocs.data && exceptExtraDocs.data.length) {
            exceptExtraDocs.data = exceptExtraDocs.data.filter((val: any) => val.fcrNumber && !val.fcrNumber.startsWith('EED'));
        }

        const cblData = this.props.cbl;
        cblData.data.map((data: any) => {
            data.number = data.cblNumber;
            data.id = data.cblId;
            data.createdDateTime = data.createdDate;
            data.updatedDateTime = data.updatedDate;
            data.essoCblOnEtVolumeFactor = data.etsCblOnEtVolumeFactor;
            data.essoEtOnCblVolumeFactor = data.etsOnCblVolumeFactor;
            return data;
        });
        const eqData = this.props.equipments;
        eqData.data.map((data: any) => {
            data.sealNumber = data.sealNumber1;
            data.equipmentId = data.equipmentTransportId;
            data.createDate = data.createdDate;
            data.updateDate = data.updatedDate;
            data.subSize = data.substitutionSize;
            data.subType = data.substitutionType;
            data.documentOnEquipmentVolume = data.etsOnDocumentVolumeFactor;
            data.etOnEssoVolumeFactor = data.etsOnEtVolumeFactor;
            data.subType = data.subType;
            return data;
        });
        const bookingData = this.props.booking;
        bookingData.data.map((data: any) => {
            data.bookingNumber = data.shipperBookingNumber;

            return data;
        });
        const customerData = this.props.customerInvoice;
        customerData.data = customerData.data.map((data: any) => {
            const newData = formatData([data]);
            return newData[0];
        });
        customerData.data = sortElementByKey(customerData.data, 'createdDate', true, 'date');
        return (
            <div className="padding-top-large padding-bottom-large">
                <Accordion title={'Organisation'} id="organisation-expand">
                    <PropertyDisplay data={[...this.props.organisation]} id="organisation" />
                </Accordion>
                <Accordion title={'Locations'} id="locations-expand">
                    <PropertyDisplay data={[...this.props.locations]} id="locations" />
                </Accordion>
                <Accordion title={'Cargo details'} id="cargoDetails-expand">
                    <PropertyDisplay className="col-20" data={[...this.props.cargoDetails]} id="cargoDetails" />
                </Accordion>
                <Accordion title={'EQUIPMENT TRANSPORT'} id="eqTransportShipments-expand">
                    <PropertyDisplay data={[...this.props.equipmentTransportShipments]} id="equipmentTransport" />
                </Accordion>
                <Accordion title={'Shipment'} id="shipment-expand">
                    <PropertyDisplay data={[...this.props.shipmentDetails]} id="shipment" />
                    <Table {...this.props.booking} id="ets-details-booking"
                        hasTotal={true}
                        linkAction={(row: any) => this.props.link(String(`/job-costing/booking/${row!.bookingId}`))} />
                </Accordion>
                {!this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'fcr'} id="fcr-expand">
                        <Table {...docData} id="ets-details-fcr"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/documents/${row!.fcrId}`))} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'Document'} id="fcr-expand">
                        <Table {...exceptExtraDocs}
                            id="ets-details-fcr"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/documents/${row!.fcrId}`))} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    extraDocs.data &&
                    extraDocs.data.length > 0 &&
                    <Accordion title={'Export Extra Document'} id="extra-document">
                        <Table {...extraDocs}
                            id="ets-details-extra-document"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/documents/${row!.fcrId}`))} />
                    </Accordion>
                }
                <Accordion title={'cbl'} id="cbl-expand">
                    <Table {...cblData}
                        id="ETS-details-cbl"
                        hasTotal={true}
                        linkAction={(row: any) => this.props.link(String(`/job-costing/cbls/${row!.id}`))} />
                </Accordion>
                <Accordion title={'equipments'} id="equipments-expand">
                    <Table {...eqData}
                        id="ETS-details-equipments"
                        hasTotal={true}
                        linkAction={(row: any) => this.props.link(String(`/job-costing/equipments/${row!.equipmentTransportId}`))} />
                </Accordion>
                <Accordion title={'voyage'} id="voyages-expand">
                    <Table {...this.props.voyages} id="ETS-details-voyages" />
                </Accordion>
                <Accordion title={'Customer Invoice'} id="customerInvoice">
                    <Table {...customerData} id="ETS-details-customerInvoice"
                        linkAction={(row: any) => {
                            redirectToViewInvoice('destination', row!.internalBillingNo);
                        }} />
                </Accordion>
            </div>
        );
    }
}

export default ETSDetails;